const SESSION_ID_STORAGE_KEY = 'platform_session_id';

export const REQUEST_ID_HEADER = 'X-Request-ID';
export const SESSION_ID_HEADER = 'X-Session-ID';

const canonicalUuidPattern =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

let inMemorySessionId: string | null = null;

export function isCanonicalUuid(value: string): boolean {
  return canonicalUuidPattern.test(value.trim());
}

function readStoredSessionId(): string | null {
  try {
    return localStorage.getItem(SESSION_ID_STORAGE_KEY);
  } catch {
    return null;
  }
}

function persistSessionId(sessionId: string): void {
  try {
    localStorage.setItem(SESSION_ID_STORAGE_KEY, sessionId);
  } catch {}
}

export function newRequestId(): string {
  return crypto.randomUUID();
}

export function getOrCreateSessionId(): string {
  const existing = readStoredSessionId();
  if (existing && isCanonicalUuid(existing)) {
    inMemorySessionId = existing.toLowerCase();
    return inMemorySessionId;
  }

  if (inMemorySessionId && isCanonicalUuid(inMemorySessionId)) {
    return inMemorySessionId;
  }

  const sessionId = crypto.randomUUID();
  inMemorySessionId = sessionId;
  persistSessionId(sessionId);
  return sessionId;
}

export function rotateSessionId(): string {
  const sessionId = crypto.randomUUID();
  inMemorySessionId = sessionId;
  persistSessionId(sessionId);
  return sessionId;
}

export function clearSessionId(): void {
  inMemorySessionId = null;
  try {
    localStorage.removeItem(SESSION_ID_STORAGE_KEY);
  } catch {}
}

export function appendTelemetryHeaders(headers: Headers): Headers {
  if (!headers.has(SESSION_ID_HEADER)) {
    headers.set(SESSION_ID_HEADER, getOrCreateSessionId());
  }
  if (!headers.has(REQUEST_ID_HEADER)) {
    headers.set(REQUEST_ID_HEADER, newRequestId());
  }
  return headers;
}
